import { render, staticRenderFns } from "./RelateDevice.vue?vue&type=template&id=c05fb6b6&scoped=true&"
import script from "./RelateDevice.vue?vue&type=script&lang=js&"
export * from "./RelateDevice.vue?vue&type=script&lang=js&"
import style0 from "./RelateDevice.vue?vue&type=style&index=0&id=c05fb6b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05fb6b6",
  null
  
)

export default component.exports